import FileThumbnail from '../file-thumbnail'
import { useFilesContext } from '../files-context'

const CurrentAsset = () => {
  const { files } = useFilesContext()

  return (
    <div className="tw-flex tw-flex-col tw-gap-1">
      <div className="tw-mb-1 tw-text-xs tw-text-neutral-500">Current asset</div>
      <div className="tw-flex tw-flex-row tw-gap-2 tw-rounded-lg tw-border tw-border-solid tw-border-neutral-200 tw-bg-neutral-50 tw-p-2">
        {files?.map((file) => {
          return <FileThumbnail key={file?.id} file={file} checkable={false} actions={false} size="sm" />
        })}
      </div>
    </div>
  )
}

export default CurrentAsset
